import { useReactiveVar } from '@apollo/client'
import { userInfoVar, userProfileVar } from 'cache/user-profile'
import { GuidanceRole, UserProfile } from 'ts/interfaces/userProfile.interface'

const emptyGuidanceRole: GuidanceRole = {}
const emptyUserProfile: UserProfile = {}

export const useGuidanceRole = () => {
  const userInfo = useReactiveVar(userInfoVar)
  return userInfo?.userSecurityProfile?.securityProfile?.guidanceRole || emptyGuidanceRole
}
export const getUserProfile = () => {
  const userInfo = userInfoVar()
  return userInfo?.userSecurityProfile?.securityProfile?.userProfile || emptyUserProfile
}

export const useUserProfile = () => {
  const userProfile = useReactiveVar(userProfileVar)

  return {
    userId: userProfile?.userId,
    userEmail: userProfile?.emailAddress,
    employeeNumber: userProfile?.employeeNumber,
    lastName: userProfile?.lastName,
    firstName: userProfile?.firstName,
  }
}
